const VYECOM_HOST_SUFFIXES = ['.vyecom.com', '.apps.vyecom.com'] as const;

/** Restrict tenant-specific auth scope to a first-party Vyecom host. */
export function organizationLoginScope(hostname: string, tenantAlias: string): string {
  const host = hostname.split(':')[0].toLowerCase();
  const alias = tenantAlias.toLowerCase();
  const trustedTenantHost = VYECOM_HOST_SUFFIXES.some((suffix) => {
    const hostAlias = host.endsWith(suffix) ? host.slice(0, -suffix.length) : '';
    return hostAlias === alias;
  });

  return trustedTenantHost ? `openid organization:${alias}` : 'openid organization';
}
